import React from 'react';

export default function Pagination({ currentPage, totalPages, setCurrentPage }) {
  const getPages = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <ul className="cs_pagination_box">
      <li>
        <button className="cs_pagination_arrow cs_center" onClick={() => handlePageClick(currentPage - 1)}>
          <img src="images/icons/left_arrow_blue.svg" alt="Prev" />
        </button>
      </li>
      {getPages().map((page) => (
        <li key={page}>
          <button
            className={`cs_pagination_item cs_center ${page === currentPage ? 'active' : ''}`}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </button>
        </li>
      ))}
      <li>
        <button className="cs_pagination_arrow cs_center" onClick={() => handlePageClick(currentPage + 1)}>
          <img src="images/icons/right_arrow_blue.svg" alt="Next" />
        </button>
      </li>
    </ul>
  );
}
